export default function SharedFormField({
  label,
  name,
  type = "text",
  value,
  onChange,
  options = [],
  placeholder,
  hint,
  error,
  required,
  rows = 4,
  children,
}) {
  const controlId = name ? `seller-field-${name}` : undefined;

  return (
    <label className="shared-field field" htmlFor={children ? undefined : controlId}>
      {label ? <span className="field-label">{label}</span> : null}
      {children ? (
        children
      ) : type === "select" ? (
        <select
          id={controlId}
          className="field-select"
          name={name}
          value={value ?? ""}
          onChange={onChange}
          required={required}
        >
          <option value="">{placeholder || "Select…"}</option>
          {options.map((option) => {
            const item = typeof option === "string" ? { value: option, label: option } : option;
            return (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            );
          })}
        </select>
      ) : type === "textarea" ? (
        <textarea
          id={controlId}
          className="field-textarea field-textarea--tall"
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          required={required}
        />
      ) : (
        <input
          id={controlId}
          className="field-input"
          type={type}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
        />
      )}
      {hint && !error ? <span className="field-hint">{hint}</span> : null}
      {error ? <span className="field-error">{error}</span> : null}
    </label>
  );
}
